// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__ozYnK","buttons":"RemoveExpirationActionButtons_buttons__2lv92"};